import {isSafari} from '@extensions/platform'

export function createDragImage(): HTMLImageElement {
  const dragImage = isSafari()
    ? (() => {
        const el = document.createElement('img')
        document.body.appendChild(el)
        return el
      })()
    : new Image()
  dragImage.src = '/img/icons/icon-checklist.svg'
  return dragImage
}
